import React from "react";
import { Box, Paper, Typography } from "@mui/material";

/** Shown when an org has PLAN_SELECTION on but no public plans configured. */
const NoPlansAvailable: React.FC = () => (
  <Box sx={{ py: 4, display: "flex", justifyContent: "center" }}>
    <Paper sx={{ p: 3, textAlign: "center", maxWidth: 480 }}>
      <Typography variant="h6" gutterBottom>No plans available yet</Typography>
      <Typography variant="body2" color="text.secondary">
        Contact your rep to get set up.
      </Typography>
    </Paper>
  </Box>
);

export default NoPlansAvailable;
